import React, { useState, useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-scroll";

const Home = () => {
  const [displayText, setDisplayText] = useState("");
  const [index, setIndex] = useState(0);
  const [isTypingComplete, setIsTypingComplete] = useState(false);
  const controls = useAnimation();
  const text = "AI and ML specialist with a strong focus on LLM, generative, and agentic AI applications, alongside computer vision. With an in-depth understanding of transformer models and hands-on experience in developing predictive models using research and open-source resources, I am dedicated to harnessing technology to enhance lives.";

  useEffect(() => {
    if (index < text.length) {
      const timer = setInterval(() => {
        console.log("Current character:", text[index]); // Log current character for debugging
        setDisplayText((prev) => prev + text[index]);
        setIndex((prev) => prev + 1);
      }, 75); // Adjusted interval to 50ms for smoother typing

      return () => clearInterval(timer);
    } else {
      setIsTypingComplete(true);
      controls.start({ opacity: 1 });
    }
  }, [index, text, controls]); // Added 'index' to the dependency array

  const cursorStyle = {
    display: isTypingComplete ? 'none' : 'inline-block',
    width: '12px',
    height: '12px',
    backgroundColor: '#00bfff', // Adjust color as needed
    borderRadius: '50%',
    boxShadow: '0 0 10px rgba(0, 191, 255, 0.7)',
    animation: 'blink 1s step-start infinite',
    marginLeft: '4px', // Adjust margin as needed
  };

  const typingContainerStyle = {
    display: 'inline-block',
    position: 'relative',
  };

  const styleTag = (
    <style>
      {`
        @keyframes blink {
          0% {
            opacity: 1;
          }
          50% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }
      `}
    </style>
  );

  return (
    <div
      name="home"
      className="h-screen w-full bg-gradient-to-b from-black via-black to-gray-800"
    >
      <div className="pt-40 max-w-screen-lg mx-auto flex flex-col items-center justify-center h-full px-4 md:flex-row">
        <div className="flex flex-col justify-center h-full">
          <h2
            style={{ fontFamily: "'Orbitron', sans-serif" }}
            className="text-4xl sm:text-7xl font-bold text-white -mt-20 md:mt-0"
          >
            AI & ML Specialist
          </h2>
          <p
            style={{ fontFamily: "sans-serif", fontSize: '24px' }} // Adjust fontSize as needed
            className="text-gray-500 py-4 max-w-lg" // Adjusted max-width to max-w-lg for increased width
          >
            <div style={typingContainerStyle}>
              {styleTag}
              <motion.span
                initial={{ opacity: 1 }}
                animate={controls}
                transition={{ duration: 0.25 }}
              >
                {displayText}
              </motion.span>
              <span style={cursorStyle}></span>
            </div>
          </p>

          <div>
            <Link
              to="portfolio"
              smooth
              duration={500}
              className="group text-white w-fit px-6 py-3 my-2 flex items-center rounded-md bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer"
            >
              Portfolio
              <span className="group-hover:rotate-90 duration-300">
                <MdOutlineKeyboardArrowRight size={25} className="ml-1" />
              </span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;














